import { useTranslation } from "react-i18next"
import { ListTabItem } from "../../../../components/customeTab/types"
import { TabsItemFilesDeatil } from "../../utils/enums/tabs"
import { useContext, useState } from "react"
import { TabsChildren } from "../../../logbook/pages/main/components/access/utils/enums/tabs"
import { useFilterTabel } from "./hooks/useFilterTable"
import { Box, IconButton, Typography } from "@mui/material"
import { BreadCrumb, CustomTable, SnackSimple } from "../../../../components"
import { CustomePanel, CustomeTab } from "../../../../components/customeTab"
import Loader from "../../../../components/loader"
import SimpleModal from "../../../../components/modal/simpleModal"
import { useBody } from "./hooks/body"
import { useTables } from "./hooks/useTable"
import { useInput } from "./hooks/useInput"
import { Permissions } from "../../../../components/permission"
import { useStyles } from "./styles"
import { icons } from "../../../../utils/icons"


export const MassivePermission = () => {

    const styles = useStyles()
    const { t } = useTranslation()


    const tabs: ListTabItem[] = [
        {
            id: TabsItemFilesDeatil.FILE,
            label: t('filesManager.tabs.filesSelect'),
            value: TabsItemFilesDeatil.FILE
        },
        {
            id: TabsItemFilesDeatil.PERMISSIONS,
            label: t('filesManager.tabs.assingPermissions'),
            value: TabsItemFilesDeatil.PERMISSIONS
        },
    ]

    const [tabValue, setTabValue] = useState(TabsItemFilesDeatil.FILE);
    const [value, setValue] = useState(TabsChildren.USERS)


    const changeTab = ({ value }: { value: TabsItemFilesDeatil }) => {
        setTabValue(value)
    }

    const [userSelected, setUserSelected] = useState<Record<string, boolean>>({})
    const { filterRow } = useFilterTabel()
    const { input, createFilter, modalLoad, loadings, cancelSearchUsers, searchUsers, loadUsers, closeSnackbar, snackbar, dataUsers, inputFilter, permissionFilter } = useInput({ setUserSelected, userSelected })
    const {
        column: columnFolio, row: rowFolio, openModal, userFolioSelected, closeModal, rowFiltered, setAllSettingsFolioUser, deleteSelected, deletedUsersSelecteds, setDeletedSelected,
    } = useTables({ tab: value, dataUsers, setUserSelected, userSelected, dataFilter: permissionFilter.filterData, filterRow })

    const body = useBody({ userFolioSelected });

    const unselectOrSelectAllUserManage = ({ value }: { value: boolean }) => {
        let body: Record<
            string,
            {
                seeFile?: boolean
                downloadFile?: boolean
            }
        > = structuredClone(userFolioSelected)

        const filter = filterRow({ list: rowFolio, value: permissionFilter.filterData })

        filter?.forEach((item) => {
            body = {
                ...body,
                [item.id?.toString() ?? '']: {
                    ...userFolioSelected[item.id?.toString() ?? ''],
                    seeFile: value,
                    downloadFile: value
                },
            }
        })

        return { body }
    }

    const unSelectOrSelectAllUsersFolios = ({ value }: { value: boolean }) => {
        const { body } = unselectOrSelectAllUserManage({ value })
        setAllSettingsFolioUser({ userFolio: body })
    }


    return (
        <Box sx={styles.container}>
            <BreadCrumb
                replaceLabels={{ editEdit: 'filesManagerEdit' }}
            />

            <CustomeTab
                listTab={tabs}
                value={tabValue}
                justifyContent="start"
                tabList={{ onChange: (_, value) => { changeTab({ value }) } }}
            >
                <CustomePanel value={TabsItemFilesDeatil.FILE}>
                    {body.tableLoading ?
                        <Loader />
                        :
                        <>
                            <Box sx={styles.headerLeft}>
                                <IconButton onClick={body.goBackToList}>{icons('arrow-left-fill')}</IconButton>
                                <Typography>{t('filesManager.buttons.backToListSecond')}</Typography>
                            </Box>

                            <Box sx={styles.containerTitle}>
                                <Typography sx={styles.title}>{t('filesManager.titles.files')}</Typography>

                                <Typography sx={styles.userSelected}>
                                    <span>{body.isCheckedAll ? (body.totalSelected - body.notSelectedFile.length) : body.fileSelected.length}</span> {t('filesManager.titles.selectedFiles', { count: body.isCheckedAll ? (body.totalSelected - body.notSelectedFile.length) : body.fileSelected.length })}
                                </Typography>
                            </Box>

                            <CustomTable
                                name="Informe General"
                                serverSidePagination={{ page: body.paginationModel.page, size: body.paginationModel.pageSize, totalPages: body.totalPages }}
                                handleChange={(page: number, pageSize: number) => {
                                    body.handlePagination({ page, pageSize })
                                }}
                                column={body.column}
                                loader={body.tableLoading}
                                row={body.row}
                                selected={-1}
                            />
                        </>
                    }
                </CustomePanel>

                <CustomePanel value={TabsItemFilesDeatil.PERMISSIONS}>
                    <Permissions
                        setValue={setValue}
                        value={value}
                        columnFolio={columnFolio}
                        deleteSelected={deleteSelected}
                        deletedUsersSelecteds={deletedUsersSelecteds}
                        loadingTable={false}
                        permissionFilter={permissionFilter}
                        rowFiltered={rowFiltered}
                        setDeletedSelected={setDeletedSelected}
                        unSelectOrSelectAllUsersFolios={unSelectOrSelectAllUsersFolios}
                        closeModal={closeModal}
                        closeSnackbar={closeSnackbar}
                        inputFilter={inputFilter}
                        openModal={openModal}
                        snackbar={snackbar}
                        cancelSearchUsers={cancelSearchUsers}
                        createFilter={createFilter}
                        input={input}
                        loadUsers={loadUsers}
                        loadings={loadings}
                        modalLoad={modalLoad}
                        searchUsers={searchUsers}
                        haveButtons
                        handleCancel={body.handleCancelPermission}
                        handleSubitmit={body.handleSubmitPermission}
                        submitLoading={body.loadingPermission}
                        textTab1={t('filesManager.titles.selectUsersToAccess')}
                        textTab2={t('filesManager.titles.usersWithPermission')}
                        tab1={t('filesManager.tabsChildren.addUsers')}
                        tab2={t('filesManager.tabsChildren.permissions')}
                    />
                </CustomePanel>
            </CustomeTab>


            <SimpleModal
                open={!!body.modal.open}
                next={body.modal.confirm}
                back={body.closeModalIndex}
                close={body.closeModalIndex}
                description={body.modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={body.modal.title}
                loadingButton={false}
            />

            <SnackSimple close={body.handleCloseSnackbar} open={body.openSnackbar.open} type={body.openSnackbar.type} message={body.openSnackbar.message} />
        </Box>
    )
}